import { Button, Flex, Modal, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

import type { ChecklistDismissReason } from 'src/analytics'

import { DISMISS_REASON_ICONS, DISMISS_REASONS } from './constants'
import { useStyles } from './styles'

const { Text } = Typography

type Props = {
  open: boolean
  onCancel: () => void
  onChoose: (reason: ChecklistDismissReason) => void
}

/**
 * Picking a reason *is* the confirmation — there is no separate OK button, so the
 * checklist can only be hidden for good together with an answer. Closing the
 * modal without choosing leaves it visible.
 */
export const DismissReasonModal = ({ open, onCancel, onChoose }: Props) => {
  const { styles } = useStyles()
  const { t } = useTranslation()

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      width={420}
      centered
      destroyOnHidden
      title={t('shell.gettingStarted.dismissModal.title')}
    >
      <Flex vertical gap={14}>
        <Text type="secondary">
          {t('shell.gettingStarted.dismissModal.subtitle')}
        </Text>
        <Flex vertical gap={8}>
          {DISMISS_REASONS.map((reason) => {
            const Icon = DISMISS_REASON_ICONS[reason]

            return (
              <Button
                key={reason}
                className={styles.reason}
                icon={<Icon size={16} />}
                onClick={() => onChoose(reason)}
              >
                {t(`shell.gettingStarted.dismissModal.reasons.${reason}`)}
              </Button>
            )
          })}
        </Flex>
      </Flex>
    </Modal>
  )
}
